<router-outlet></router-outlet>

<!--Global-->
<app-loader></app-loader>
